<template>
	<nav class="left-nav">
		<div class="left-nav__title">
			<p>{{ currentModule.title }}</p>
			<p>{{ currentModule.title_en }}</p>
		</div>
		<div class="left-nav__list">
			<ul>
				<router-link
					:to="nav.path"
					class="left-nav__item"
					:class="{
						'left-nav__item--active': $route.path.includes(
							nav.name
						),
					}"
					v-for="nav in currentModule.children"
					:key="nav.title"
					tag="li"
				>
					<span>{{ nav.title }}</span>
				</router-link>
			</ul>
		</div>
	</nav>
</template>

<script>
export default {
	props: {
		currentModule: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {}
	},
	created() {},
	mounted() {},
	watch: {},
	methods: {},
	components: {},
}
</script>

<style lang="scss">
.left-nav {
	&__title {
		width: 250px;
		padding: 15px 10px;
		border-bottom: 1px solid $corss-line-color;
		& > p:first-child {
			display: flex;
			align-items: center;
			color: $active-color;
			font-size: 21px;
			&::before {
				content: '';
				display: inline-block;
				width: 4px;
				height: 20px;
				background-color: $active-color;
				margin-right: 10px;
			}
		}
		& > p:nth-of-type(2) {
			font-size: 12px;
			color: $corss-line-color;
		}
	}
	&__list {
		& .left-nav__item {
			cursor: pointer;
			color: #000000;
			padding: 20px;
			transition: all 0.3s ease-in-out;
			&::before {
				content: '';
				display: inline-block;
				width: 0;
				height: 0;
				border: 6px solid;
				border-color: transparent transparent transparent #ffffff;
			}
			&--active {
				background-color: $active-color;
				color: #ffffff;
			}
		}
	}
}
</style>
